import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import axios from 'axios'

Vue.config.productionTip = false

export const bus = new Vue()

export const zirafHTTP = axios.create({
	baseURL: process.env.VUE_APP_AXIOS_BASEURL
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
